"use client";

import { createContext, useContext, ReactNode } from "react";

import { ILocaleValue } from "@types";

export interface IPageData {
  fields: any;
  hubspotGeneralSegment?: string;
  titles: {
    page: ILocaleValue[];
    shortTitle: string;
    parent?: ILocaleValue[];
    overview?: ILocaleValue[];
  };
  slugs: {
    page: ILocaleValue[];
    parent?: ILocaleValue[];
    overview?: ILocaleValue[];
  };
}

const PageDataContext = createContext<IPageData | null>(null);

interface PageDataProviderProps {
  fields: any;
  hubspotGeneralSegment?: string;
  children: ReactNode;
}

export const PageDataProvider = ({
  fields,
  hubspotGeneralSegment,
  children,
}: PageDataProviderProps) => {
  const pageData: IPageData = {
    fields,
    hubspotGeneralSegment,
    titles: {
      page: fields.titles || [],
      shortTitle: fields.shortTitle || "",
      ...(fields.parent && { parent: fields.parent.titles }),
      ...(fields.overview && { overview: fields.overview.titles }),
    },
    slugs: {
      page: fields.slugs || [],
      ...(fields.parent && { parent: fields.parent.slugs }),
      ...(fields.overview && { overview: fields.overview.slugs }),
    },
  };

  return <PageDataContext.Provider value={pageData}>{children}</PageDataContext.Provider>;
};

export const usePageData = (): IPageData => {
  const ctx = useContext(PageDataContext);
  if (!ctx) throw new Error("usePageData must be used inside PageDataProvider");
  return ctx;
};

export const useHubspotGeneralSegment = (): string | undefined => {
  return useContext(PageDataContext)?.hubspotGeneralSegment;
};
